import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColumnNamePipe } from '../../../pipes/column-name.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FiltersComponent } from '../filters/filters.component';
import { FilterModel } from '../../../core/models/filters/filters.model';
import { ChatStatus } from '../../../../enums/chat-status.enum';
import { StatusUtils } from '../../../utils/status-utils';
import { CaseStatus } from '../../../../enums/case-status.enum';
import { ColumnModel } from '../../../core/models/table/column.model';
import { SortModel } from '../../../core/models/filters/sort.model';
import { PaginationComponent } from '../pagination/pagination.component';
import { ActionButtonClickModel } from '../../../core/models/action-button/action-button-click.model';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DeleteModalComponent } from '../modals/delete-modal/delete-modal.component';
import { PaymentMethod } from '../../../../enums/payment-method.enum';
import { InvoiceActionsComponent } from '../invoice-actions/invoice-actions.component';
import { PatientsService } from '../../../core/services/patient/patients.service';
import { CurrentUserService } from '../../../core/services/user/current-user.service';
import { ToastService } from '../../../core/services/toast.service';
import { ConsultationsService } from '../../../core/services/consultation/consultations.service';
import { UserStatus } from '../../../../enums/user-status.enum';
import { TableService } from './services/table.service';
import { UsersService } from '../../../core/services/user/users.service';
import { Observable } from 'rxjs';
declare var bootstrap: any;

export interface TableData {
  [key: string]: string | number | Date;
}

@Component({
  selector: 'app-tables',
  standalone: true,
  imports: [
    DatePipe,
    CommonModule,
    FormsModule,
    TranslateModule,
    FiltersComponent,
    PaginationComponent,
    RouterModule,
    DeleteModalComponent,
    InvoiceActionsComponent,
  ],
  templateUrl: './tables.component.html',
  styleUrl: './tables.component.scss',
  providers: [DatePipe, ColumnNamePipe],
})
export class TablesComponent implements OnInit, AfterViewInit, OnChanges {
  // @Input() 
  data: any[] = [];
  @Input() columns: ColumnModel[] = [];
  @Input() filters: FilterModel[] = [];
  @Input() sort: SortModel | null = null;
  @Input() url: string = '';
  @Input() tableHeader: string = '';
  @Input() footerText: string = '';
  @Input() signalModel: any;
  // @Input()
  tableLoading: boolean = false;
  @Input() columnWidths: string[] = [];
  // @Input()
  totalCount: number = 0;
  // @Input()
  totalPage: number = 0;
  // @Input() 
  pageSize: number = 10;
  @Input() iconPath: string;

  // @Output() filtersChange = new EventEmitter<{
  //   filters: FilterModel[] | null;
  //   sort: SortModel | null;
  // }>();
  // @Output() onChangePage = new EventEmitter<{
  //   page: number;
  //   pageSize: number;
  // }>();
  // @Output() onPageChange = new EventEmitter<number>();
  // @Output() onPageSizeChange = new EventEmitter<number>();
  @Output() onActionButtonClick = new EventEmitter<ActionButtonClickModel>();
  // @Output() handleGetPatientList = new EventEmitter<void>();
  // @Output() handleGetAppointmentList = new EventEmitter<void>();
  // @Output() handleGetConsultationList = new EventEmitter<void>();
  // @Output() handleGetReferralList = new EventEmitter<void>();
  // @Output() handleGetUserList = new EventEmitter<void>();

  ChatStatus = ChatStatus;
  caseStatuses = StatusUtils?.getFilterCaseStatuses();
  caseStatus = CaseStatus;
  userStatus = UserStatus;

  sortColumn: string | null = null;
  sortDirection: null | 'ascending' | 'descending' = null;
  pageSizes = [10, 25, 50, 100];
  currentPage: number = 1;
  deleteModalId: string = '';
  invoiceModalId: string = '';
  maxDate: string;
  @Input() type: string = '';
  filterForm = {
    customerCode: '',
    year: null as number | null,
    month: null as number | null,
    doctor: '',
    pageSize: 10,
  };
  lastScrollPosition: number = 0;


  currentYear = new Date().getFullYear();
  minYear = this.currentYear - 5;
  maxYear = this.currentYear + 5;
  listName: string = '';
  isPatientList: boolean = window.location.href.includes('patient');
  isConsultationList: boolean = window.location.href.includes('consultation');
  isReferralList: boolean = window.location.href.includes('referral');
  isAppointmentList: boolean = window.location.href.includes('appointment');
  isUserList: boolean = window.location.href.includes('/user/list');
  isInvoiceList: boolean = window.location.href.includes('invoice');
  patientRecordId: string = '';
  pidNo: string = '';
  paymentMethod = PaymentMethod;
  isLoad: boolean = false;
  constructor(
    private translate: TranslateService,
    private router: Router,
    private patientsService: PatientsService,
    private consultationsService: ConsultationsService,
    private route: ActivatedRoute,
    private tableService: TableService,
    private userService: UsersService,
    private currentUserService: CurrentUserService,
    private toastService: ToastService
  ) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
    const today = new Date();
    this.maxDate = today.toISOString().split('T')[0];
  }
  private onScroll = this.handleScroll.bind(this);
  handleScroll(event: Event) {
    this.lastScrollPosition = window.scrollY;
    this.setParams();
  }
  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.onScroll);
  }
  async ngOnInit() {
    await StatusUtils?.initializeTranslateService(this.translate);
    this.caseStatuses = StatusUtils?.getFilterCaseStatuses();
    this.getList().subscribe(e => {
      setTimeout(() => {
        this.setConfig();
      }, 100);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['signalModel']) {
      this.filterSignalModel(this.signalModel);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      window.addEventListener('scroll', this.onScroll);
    }, 0);
  }

  filterSignalModel(signalModel: any) {
    if (this.type === 'dermaiList') {
      this.applyDermAiLockSignal(signalModel);
      return;
    }

    const index = this.data.findIndex(
      (patient) => patient.patientId === signalModel?.PatientId
    );
    
    if (index !== -1) {
      const updatedPatients = [...this.data];
      updatedPatients[index] = {
        ...updatedPatients[index],
        patientStatus: signalModel.PatientStatus,
      };
      this.data = updatedPatients;
      
    }
  }

  private applyDermAiLockSignal(signalModel: any) {
    if (!signalModel) return;

    if (signalModel.kind === 'snapshot') {
      const locks = Array.isArray(signalModel.locks) ? signalModel.locks : [];
      const byCase = new Map<string, any>(
        locks.map((lock: any) => [lock.caseId, lock])
      );
      this.data = this.data.map((row) => {
        const lock =
          byCase.get(row.pendingFollowUpCaseId) || byCase.get(row.caseId);
        if (!lock) {
          return {
            ...row,
            isLocked: false,
            lockedByUserId: null,
            lockedByDoctorName: null,
          };
        }
        return {
          ...row,
          isLocked: true,
          lockedByUserId: lock.lockedByUserId,
          lockedByDoctorName: lock.lockedByDoctorName,
          lockedAt: lock.lockedAt,
        };
      });
      return;
    }

    const caseId = signalModel.caseId;
    if (!caseId) return;

    if (signalModel.kind === 'completed') {
      this.data = this.data
        .map((row) => {
          if (row.pendingFollowUpCaseId === caseId) {
            return {
              ...row,
              hasPendingFollowUp: false,
              pendingFollowUpCaseId: null,
              pendingFollowUpStatus: null,
              caseStatusName: 'ConclusionSubmitted',
              reviewType: 'DermatologistReview',
              isLocked: false,
              lockedByUserId: null,
              lockedByDoctorName: null,
            };
          }
          return row;
        })
        .filter((row) => row.caseId !== caseId);
      return;
    }

    const index = this.data.findIndex(
      (row) => row.caseId === caseId || row.pendingFollowUpCaseId === caseId
    );
    if (index === -1) return;

    const updated = [...this.data];
    if (signalModel.kind === 'unlocked') {
      updated[index] = {
        ...updated[index],
        isLocked: false,
        lockedByUserId: null,
        lockedByDoctorName: null,
      };
    } else {
      updated[index] = {
        ...updated[index],
        isLocked: true,
        lockedByUserId: signalModel.lockedByUserId,
        lockedByDoctorName: signalModel.lockedByDoctorName,
        lockedAt: signalModel.lockedAt,
      };
    }
    this.data = updated;
  }

  isDermAiLockedByOther(row: any): boolean {
    if (this.type !== 'dermaiList' || !row?.isLocked) return false;
    const currentUserId = this.currentUserService.GetSession()?.id;
    return !!row.lockedByUserId && row.lockedByUserId !== currentUserId;
  }

  getShortCaseId(value: string | null | undefined): string {
    if (!value) return '-';
    return value.length > 8 ? value.slice(0, 8) : value;
  }

  getDermAiStatusText(row: any): string {
    if (row?.caseStatusName === 'FollowUpPending' || row?.hasPendingFollowUp) {
      return this.translate.instant('dermoscanFollowUpPending');
    }
    const statusKeyByName: Record<string, string> = {
      Created: 'dermoscanStatusCreated',
      SendAi: 'dermoscanStatusSendAi',
      AiResultSuccess: 'dermoscanStatusAiResultSuccess',
      AiResultFailure: 'dermoscanStatusAiResultFailure',
      ConclusionSubmitted: 'dermoscanStatusConclusionSubmitted',
    };
    const statusKeyByNumber: Record<number, string> = {
      0: 'dermoscanStatusCreated',
      1: 'dermoscanStatusSendAi',
      2: 'dermoscanStatusAiResultSuccess',
      3: 'dermoscanStatusAiResultFailure',
      4: 'dermoscanStatusConclusionSubmitted',
    };
    const translationKey =
      statusKeyByName[row?.caseStatusName] || statusKeyByNumber[row?.caseStatus];
    if (translationKey) {
      return this.translate.instant(translationKey);
    }
    return row?.caseStatusName || '-';
  }

  getDermAiStatusBadgeClass(row: any): string {
    if (row?.caseStatusName === 'FollowUpPending' || row?.hasPendingFollowUp) {
      return 'badge-light-warning';
    }
    const status = row?.caseStatusName || row?.caseStatus;
    switch (status) {
      case 'Created':
      case 0:
        return 'badge-light-secondary';
      case 'SendAi':
      case 1:
        return 'badge-light-info';
      case 'AiResultSuccess':
      case 2:
        return 'badge-light-primary';
      case 'AiResultFailure':
      case 3:
        return 'badge-light-danger';
      case 'ConclusionSubmitted':
      case 4:
        return 'badge-light-success';
      default:
        return 'badge-light-primary';
    }
  }

  getDermAiReviewTypeText(row: any): string {
    if (row?.reviewType === 'FollowUp' || row?.hasPendingFollowUp) {
      return this.translate.instant('followUpConsultation');
    }
    if (row?.reviewType === 'AI') {
      return this.translate.instant('followUpHistoryAiAnalysis');
    }
    if (
      row?.reviewType === 'DermatologistReview' ||
      row?.reviewType === 'Dermatologist'
    ) {
      return this.translate.instant('followUpHistoryDermatologistReview');
    }
    return row?.reviewType || '-';
  }

  getDermAiReviewTypeBadgeClass(row: any): string {
    if (row?.reviewType === 'FollowUp' || row?.hasPendingFollowUp) {
      return 'badge-light-warning';
    }
    if (row?.reviewType === 'AI') {
      return 'badge-light-primary';
    }
    return 'badge-light-info';
  }

  getDermAiPaymentStatusText(row: any): string {
    if (row?.paymentSucceeded || row?.paymentStatus === 'PaymentSucceed') {
      return this.translate.instant('dermoscanPaymentSucceed');
    }
    if (!row?.paymentStatus) {
      return '-';
    }
    return this.translate.instant('dermoscanPaymentPending');
  }

  getDermAiPaymentStatusBadgeClass(row: any): string {
    if (row?.paymentSucceeded || row?.paymentStatus === 'PaymentSucceed') {
      return 'badge-light-success';
    }
    if (!row?.paymentStatus) {
      return 'badge-light-secondary';
    }
    return 'badge-light-warning';
  }

  getList(): Observable<boolean> {
    return new Observable(observer => {
      this.tableLoading = true;
      let updatedFilters: any = this.filters;
      if (this.type == "branchReportList") {
        let userBranches: any;
        this.userService.getUserBranchesByCustomerCode().then(br => {
          userBranches = br;
          updatedFilters = {
            ...this.filters,
            userBranches: userBranches || [],
          };
          this.callFunctionList(updatedFilters).subscribe(e => {
            observer.next(true);
          })
        });
      } else {
        this.callFunctionList(updatedFilters).subscribe(e => {
          observer.next(true);
        })
      }
    })
  }

  callFunctionList(updatedFilters: any): Observable<boolean> {
    return new Observable((observer => {
      this.tableService
        .getList(this.currentPage, this.pageSize, this.url, this.type, updatedFilters, this.sort)
        .subscribe({
          next: (res) => {
            this.data = res.items;
            if (this.type == "userList") {
              this.data = res.items.map((user) => ({
                ...user,
                roleName: this.translate.instant(user.roleName),
              }));
            }
            this.totalCount = res.count;
            this.totalPage = res.pages;
            this.pageSize = this.pageSize;
            this.currentPage = this.currentPage;
            this.tableLoading = false;
            observer.next(true);
          },
        });
    }))

  }

  setConfig() {
    let params = this.route.snapshot.queryParams;
    if (params) {
      Object.keys(params).map((key) => {
        this.filters.map((item) => {
          if (item.filterId == key) {
            item.value = params[key];
          }
          return item;
        });

        if (key == "sort") {
          this.sort = JSON.parse(params[key]);
        }
        if (key == "pageSize") {
          this.pageSize = +params[key];
        }
        if (key == "page") {
          this.currentPage = +params[key];
        }
        if (key == "scrollPosition") {
          this.lastScrollPosition = +params[key];
        }
      });
        setTimeout(() => {
          if (this.lastScrollPosition != 0) {
            window.scrollTo({ top: this.lastScrollPosition, behavior: 'auto' });
          }
        }, 1000);

        this.filterList(this.filters);
        // this.pageChange(this.currentPage);
        this.pageSizeChange(this.pageSize, this.currentPage);
        if (this.sort) {
          this.sortDirection = this.sort.orderBy;
          this.sortTable(this.sort.column);
        }
    }

  }

  filterList(e: FilterModel[]) {
    this.filters = e;
    this.setParams();
    this.getList().subscribe();
    // this.filtersChange.emit({ filters: e, sort: null });
  }

  getTotalForLastColumn(): number {
    const lastColumnKey = this.columns[this.columns.length - 1];
    return this.data.reduce((total, row) => {
      const value = row[lastColumnKey.key];
      return total + (typeof value === 'number' ? value : 0);
    }, 0);
  }

  getStatusName(status: number): string {
    return StatusUtils?.getCaseStatusText(status);
  }

  getStatusClass(status: number): string {
    return StatusUtils?.getCaseStatusClass(status);
  }

  getUserStatusClass(status: string): string {
    const formatttedStatus = parseInt(status);
    return StatusUtils?.getUserStatusClass(formatttedStatus);
  }

  getUserStatusText(status: string): string {
    const formatttedStatus = parseInt(status);
    return StatusUtils?.getUserStatusText(formatttedStatus);
  }

  getAppointmentStatusClass(status: number): string {
    return StatusUtils?.getAppointmentStatusClass(status);
  }

  getAppointmentStatusText(status: number): string {
    return StatusUtils?.getAppointmentStatusText(status);
  }

  getChatStatusClass(status: number): string {
    return StatusUtils?.getChatStatusClass(status);
  }

  getChatStatusText(status: ChatStatus): string {
    return StatusUtils?.getChatStatusText(status);
  }

  setBlockOrActiveForUser(row: any, column: any, type: 'activate' | 'block') {
    const isActive = row.userStatus === UserStatus.Active;
    const isBlocked = row.userStatus === UserStatus.Blocked;
    const isDeActive = row.userStatus === UserStatus.DeActive;
    const isNewAccount = row.userStatus === UserStatus.NewAccount;

    const canBlock = column.actionTypes.includes(type) && isActive;
    const canActivate =
      column.actionTypes.includes(type) &&
      (isBlocked || isDeActive || isNewAccount);

    return type === 'block' ? canBlock : canActivate;
  }

  sortTable(key: string) {
    if (this.sortColumn === key) {
      this.sortDirection =
        this.sortDirection === null
          ? 'ascending'
          : this.sortDirection === 'ascending'
            ? 'descending'
            : null;
    } else {
      this.sortColumn = key;
      this.sortDirection = 'ascending';
    }

    if (this.sortDirection === null) {
      this.sortColumn = null;
    }

    const sortModel: SortModel = { column: key, orderBy: this.sortDirection };
    this.sort = sortModel;
    this.setParams();
    this.getList().subscribe();
    // this.filtersChange.emit({
    //   filters: this.filters,
    //   sort: sortModel ? sortModel : null,
    // });
  }

  setParams() {
    let searchParams: any = {};
    this.filters.map((item) => {
      if (item.value) {
        searchParams[item.filterId] = item.value;
      }
    });

    // Create new params object instead of merging with current params
    const updatedParams: any = {
      ...searchParams,
      pageSize: this.pageSize,
      page: this.currentPage
    };

    // Only add sort if it exists
    if (this.sort) {
      updatedParams.sort = JSON.stringify(this.sort);
    }

    // Remove null/undefined values that would appear as "null" in URL
    Object.keys(updatedParams).forEach(key => {
      if (updatedParams[key] === null || updatedParams[key] === undefined) {
        delete updatedParams[key];
      }
    });
    updatedParams.scrollPosition = this.lastScrollPosition;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: updatedParams,
      queryParamsHandling: null, // Don't merge with existing params
      replaceUrl: true
    });
  }


  pageChange(page: any): void {
    this.currentPage = page;
    // this.onPageChange.emit(page);
    this.getList().subscribe();
    this.setParams();
  }

  pageSizeChange(size: any, page?: any): void {
    this.pageSize = size;
    this.currentPage = page ? page : 1;
    // this.onPageSizeChange.emit(size);
    this.getList().subscribe();
    this.setParams();
  }

  handleRouting(row: any) {
    if (this.isConsultationList) {
      this.assignDoctor(row.patientRecordId);
    } else if (this.isPatientList) {
      this.goToPatientDetail(row.patientId);
    } else if (this.type === 'dermaiList') {
      if (this.isDermAiLockedByOther(row)) return;
      this.goToDermAiConsultationDetail(row);
    } else if (this.isAppointmentList) {
      this.goToAppointmentDetail(row);
    } else if (this.isReferralList) {
      this.goToReferralDetail(row.patientRecordId);
    }
  }

  handleCursorPointer() {
    if (
      this.isConsultationList ||
      this.isPatientList ||
      this.isAppointmentList ||
      this.isReferralList ||
      this.type === 'dermaiList'
    ) {
      return 'cursor-pointer';
    }
    return '';
  }

  actionButtonClick(actionType: string, row: any) {
    this.onActionButtonClick.emit({ actionType, row });
  }

  goToPatientDetail(patientRecordId: string) {
    this.router.navigate(['/patient/detail', patientRecordId]);
  }

  private getLatestCompletedDermatologistFollowUpId(row: any): string | null {
    const followUps = row?.followUps;
    if (!Array.isArray(followUps) || !followUps.length) {
      return null;
    }

    const latest = [...followUps]
      .filter(
        (followUp) =>
          followUp?.isDermatologistReview &&
          (followUp.caseStatus === 4 ||
            followUp.caseStatusName === 'ConclusionSubmitted')
      )
      .sort((left, right) => {
        const leftTime = new Date(left.createdDate).getTime();
        const rightTime = new Date(right.createdDate).getTime();
        return leftTime - rightTime;
      })
      .pop();

    return latest?.caseId ?? null;
  }

  goToDermAiConsultationDetail(row: any) {
    const targetCaseId =
      row?.pendingFollowUpCaseId ||
      this.getLatestCompletedDermatologistFollowUpId(row) ||
      row.caseId;
    const isCompleted =
      !row?.pendingFollowUpCaseId &&
      (row?.caseStatus === 4 || row?.caseStatusName === 'ConclusionSubmitted');
    if (isCompleted) {
      this.router.navigate(['/dermoscan/dermconsultation', targetCaseId]);
      return;
    }

    this.patientsService.acquireMobilePatientCaseLock(targetCaseId).subscribe({
      next: (lock) => {
        if (lock?.lockToken) {
          sessionStorage.setItem(`dermoscan-lock-${targetCaseId}`, lock.lockToken);
        }
        this.router.navigate(['/dermoscan/dermconsultation', targetCaseId]);
      },
      error: (error) => {
        const body = error?.error ?? {};
        const doctorName = body.lockedByDoctorName || body.LockedByDoctorName;
        row.isLocked = true;
        row.lockedByUserId = body.lockedByUserId || body.LockedByUserId;
        row.lockedByDoctorName = doctorName;
        this.data = [...this.data];
        const message = doctorName
          ? this.translate.instant('dermoscanCaseLockedBy').replace('{name}', doctorName)
          : this.translate.instant('dermoscanCaseLocked');
        this.toastService.showToast(message, 'error');
      },
    });
  }

  goToReferralDetail(patientRecordId: string) {
    this.router.navigate(['/referral/detail', patientRecordId]);
  }

  goToAppointmentDetail(rowData: any) {
    this.patientsService
      .patientInformationByEmail(rowData.patientRecordId)
      .subscribe({
        next: (res) => {
          if (res?.isExist) {
            this.router.navigate([
              '/patient/appointment-detail',
              rowData.patientId,
              rowData.id,
            ]);
          } else {
            this.router.navigate(['/patient/appointment-detail', rowData.id]);
          }
        },
      });
  }

  assignDoctor(patientRecordId: string) {
    if (this.isConsultationList) {
      this.consultationsService
        .assignDoctorToPatientRecord(patientRecordId)
        .subscribe({
          next: (res) => {
            if (res && res.isSuccess) {
              this.router.navigate(['/consultation/detail', patientRecordId]);
            }
          },
        });
    }
  }

  handleDelete(row: any, event: Event) {
    event.stopPropagation();
    if (this.isPatientList) {
      this.listName = 'patient-list';
      this.setDeleteModalId(row.patientId);
    } else if (this.isAppointmentList) {
      this.listName = 'appointment-list';
      this.setDeleteModalId(row.id);
    } else if (this.isConsultationList) {
      this.listName = 'consultation-list';
      this.setDeleteModalId(row.patientRecordId);
    } else if (this.isReferralList) {
      this.listName = 'referral-list';
      this.setDeleteModalId(row.patientRecordId);
    } else if (this.isUserList) {
      this.listName = 'user-list';
      this.setDeleteModalId(row.id);
    }
  }

  setDeleteModalId(id: string) {
    this.deleteModalId = id;
    setTimeout(() => {
      const modalElement = document.getElementById('deleteModal-' + id);
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    });
  }

  deleteEvent() {
    this.currentPage = 1;
    this.getList().subscribe();
  }
}
